<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import Loading from '@/components/Loading.vue'
import SensorVirtualPeriodo from '@/components/sensor-virtual/SensorVirtualPeriodo.vue'
import http from '@/utils/http'

export default {
  name: 'EquipamentoTemplateInput',
  components: { SensorVirtualPeriodo, Loading },
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      opened: false,
      form: {
        id: null,
        descricao: '',
      },
      tipoSensores: null,
    }
  },
  validations: {
    form: {
      descricao: {
        required,
      },
    },
  },
  computed: {
    isEdit() {
      return !!this.form.id
    },
    buttomText() {
      return this.isEdit ? 'Editar' : 'Cadastrar'
    },
  },
  async beforeMount() {
    await this.buscarTipos()

    if (this.$route.params.templateId) {
      this.form.id = this.$route.params.templateId
      this.buscarEquipamentoTemplate(this.$route.params.templateId)
    }
  },
  methods: {
    async buscarTipos() {
      this.tipoSensores = (await http.get('/tiposSensores')).tiposSensores

      this.tipoSensores = this.tipoSensores.reduce((acc, tipo) => {
        acc[tipo.id] = {
          ...tipo,
          quantidade: 0,
        }

        return acc
      }, {})
    },
    buscarEquipamentoTemplate(id) {
      this.loading = true
      http
        .get(`/template-equipamento/${id}`)
        .then((response) => {
          this.form = response

          Object.entries(response.template).forEach(([key, count]) => {
            this.tipoSensores[key].quantidade = count
          })
        })
        .finally(() => (this.loading = false))
    },
    addQuantidadeSensor(id, add) {
      const sensor = this.tipoSensores[id]

      if (!sensor) {
        return
      }

      if (sensor.quantidade + add < 0) {
        return
      }

      sensor.quantidade += add
    },
    submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.loading = true

      const template = Object.entries(this.tipoSensores)
        .filter(([, sensor]) => sensor.quantidade > 0)
        .map(([id, sensor]) => {
          return {
            tipoSensorId: id,
            quantidade: sensor.quantidade,
          }
        })
        .reduce((acc, sensor) => {
          acc[sensor.tipoSensorId] = sensor.quantidade
          return acc
        }, {})

      const data = {
        ...this.form,
        template,
      }

      const request = this.isEdit
        ? http.put(`/template-equipamento`, data)
        : http.post(`/template-equipamento`, data)

      request
        .then(() => {
          this.$router.push({ name: 'EquipamentoTemplateIndex' })
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<template>
  <div>
    <loading :loading="loading" />
    <form v-if="!loading" action="" class="md-layout" @submit.prevent="submit">
      <div class="md-layout-item">
        <md-card-header>
          <div class="md-title">Cadastrar Template Equipamento</div>
        </md-card-header>
        <md-card-content>
          <md-field :class="getValidationClass('descricao')">
            <label for="descricao">Descrição</label>
            <md-input id="descricao" v-model="form.descricao" />
            <span v-if="!$v.form.descricao.required" class="md-error"
              >Descrição é obrigatório</span
            >
          </md-field>

          <div
            v-for="sensor in tipoSensores"
            :key="sensor.id"
            class="md-layout"
            style="text-align: center"
          >
            <div class="md-layout-item md-size-5">
              <md-button
                class="md-icon-button md-primary"
                @click="() => addQuantidadeSensor(sensor.id, -1)"
              >
                <md-icon>remove</md-icon>
              </md-button>
            </div>

            <div
              class="md-layout-item md-size-5 mt-2"
              style="text-align: center"
            >
              <span class="md-subheading">
                {{ sensor.quantidade }}
              </span>
            </div>

            <div class="md-layout-item md-size-5">
              <md-button
                class="md-icon-button md-primary"
                @click="() => addQuantidadeSensor(sensor.id, 1)"
              >
                <md-icon>add</md-icon>
              </md-button>
            </div>

            <div
              class="md-layout-item mt-2 pl-4 md-size-40"
              style="text-align: left"
            >
              {{ sensor.tipo }}
            </div>
          </div>

          <div class="botoes">
            <md-button
              class="md-raised md-accent"
              @click.prevent="$router.back()"
            >
              Voltar
            </md-button>
            <md-button type="submit" class="md-raised md-primary">
              {{ buttomText }}
            </md-button>
            <md-progress-spinner
              v-if="loading"
              :md-diameter="40"
              :md-stroke="5"
              md-mode="indeterminate"
            />
          </div>
        </md-card-content>
      </div>
    </form>
  </div>
</template>

<style scoped lang="scss"></style>
